import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import {
  IconCard,
  IconChevronRight,
  IconCoin,
  IconX,
} from "../../profile/icons";
import "./Deposit.css";

const Deposit = ({ open, type, onClose }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const closeRef = useRef(null);

  useEffect(() => {
    if (open) closeRef.current?.focus();
  }, [open]);

  const configs = {
    deposit: {
      title: t("deposit.output_crypto.title"),
      subtitle: t("deposit.output_crypto.subtitle"),
      items: [
        {
          title: t("depositBlock.crypto"),
          description: t("depositBlock.cryptoChange"),
          link: "/account/deposit-crypto",
        },
        {
          title: t("depositBlock.fiat"),
          description: t("depositBlock.fiatChange"),
          link: "/account/deposit",
        },
      ],
    },
    withdrawal: {
      title: t("deposit.withdrawal.title"),
      subtitle: t("deposit.withdrawal.subtitle"),
      items: [
        {
          title: t("deposit.withdrawal.items.crypto.title"),
          description: t("deposit.withdrawal.items.crypto.description"),
          link: "/account/withdraw-crypto",
        },
        {
          title: t("deposit.withdrawal.items.fiat.title"),
          description: t("deposit.withdrawal.items.fiat.description"),
          link: "/account/withdraw",
        },
      ],
    },
  };

  const cfg = configs[type];
  if (!cfg) return null;

  return (
    <div
      className={`fxh-modal${open ? " open" : ""}`}
      role="dialog"
      aria-modal="true"
      aria-label={cfg.title}
      onClick={(e) => e.stopPropagation()}
    >
      <div className="fxh-mhead">
        <div>
          <h2>{cfg.title}</h2>
          <p>{cfg.subtitle}</p>
        </div>
        <button
          type="button"
          ref={closeRef}
          className="fxh-icon-btn"
          onClick={onClose}
          aria-label={t("common.close", "Закрыть")}
        >
          <IconX />
        </button>
      </div>

      <div className="fxh-mlist">
        {cfg.items.map((item, i) => (
          <button
            key={item.link}
            type="button"
            className="fxh-mitem"
            onClick={() => {
              navigate(item.link);
              onClose(); // если мы уже на этой странице, маршрут не сменится — закрываем сами
            }}
          >
            <span className="fxh-mico">
              {i === 0 ? (
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  version="1.1"
                  xmlnsXlink="http://www.w3.org/1999/xlink"
                  width={512}
                  height={512}
                  x={0}
                  y={0}
                  viewBox="0 0 512 512"
                  style={{ enableBackground: "new 0 0 512 512" }}
                  xmlSpace="preserve"
                  className="fx-ico"
                >
                  <g>
                    <path
                      d="M256.198 0C114.804-.119.119 114.408 0 255.802S114.408 511.881 255.802 512c141.375-.119 255.98-114.625 256.198-256C512 114.685 397.513.119 256.198 0m-.396 469.4c-117.855 0-213.399-95.545-213.399-213.4S137.947 42.601 255.802 42.601c117.815.119 213.28 95.584 213.399 213.399 0 117.855-95.544 213.4-213.399 213.4"
                      fill="#10c97f"
                      opacity={1}
                      data-original="#000000"
                      className=""
                    />
                    <path
                      d="M324.954 243.517c17.12-9.65 26.373-28.968 23.183-48.347-3.963-29.919-39.628-41.214-67.765-43.591v-44.978h-27.74v44.582h-18.625v-44.582h-27.74v44.582H150.39v28.731h20.805c9.313 0 13.87 2.774 13.87 10.303V313.66c0 10.303-5.152 13.474-10.7 13.474h-21.201v29.325h53.895v45.573h27.938v-45.573h18.625v45.573h27.146v-45.573h5.944c57.065 0 76.087-27.938 76.087-65.981-.456-22.431-16.01-41.73-37.845-46.961m-90.948-61.82h19.814c13.87 0 41.214 2.378 41.214 24.966.951 14.742-9.729 27.661-24.372 29.523h-36.656zm30.712 142.662v-.198h-30.712v-59.443h35.666c8.322 0 39.628 2.774 39.628 24.966s-14.86 34.675-44.582 34.675"
                      fill="#10c97f"
                      opacity={1}
                      data-original="#000000"
                      className=""
                    />
                  </g>
                </svg>
              ) : (
                <IconCard />
              )}
            </span>
            <span className="fxh-mtext">
              <b>{item.title}</b>
              <span>{item.description}</span>
            </span>
            <IconChevronRight className="go" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default Deposit;
